import React from 'react'
import {useI18n} from 'i18n/I18nContext'
import {getEventFaqEntry} from './eventFaqData'
import type {EventFaqKey} from './eventFaqKeys'

export function EventFaqHelp(props: {faqKey: EventFaqKey}) {
  const {locale} = useI18n()
  const {a} = getEventFaqEntry(locale, props.faqKey)
  return (
    <div
      style={{
        whiteSpace: 'pre-line',
        maxWidth: 420,
        fontSize: 14,
        lineHeight: 1.5,
      }}
    >
      {a}
    </div>
  )
}
